import { ApiError, httpClient } from "@bw/shared/api";
import type { UUID } from "@bw/shared/types";
import type {
  ContractTermsResponse,
  DefaultContractTermsPublicationResult,
  DefaultContractTermsState,
  PublishDefaultContractTermsRequest,
  OrgResponse,
  OrgContractTermsVersionResponse,
  PlatformOnboardingPipeline,
  PublishContractVersionRequest,
} from "@bw/shared/types/generated";

export async function getOrg(orgId: UUID): Promise<OrgResponse> {
  return httpClient.get<OrgResponse>(`/platform/orgs/${orgId}`);
}

export async function getContractTerms(
  orgId: UUID,
): Promise<ContractTermsResponse | null> {
  try {
    return await httpClient.get<ContractTermsResponse>(
      `/platform/orgs/${orgId}/contract-terms`,
    );
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      return null;
    }
    throw error;
  }
}

export async function publishContractVersion(
  orgId: UUID,
  data: PublishContractVersionRequest,
): Promise<OrgContractTermsVersionResponse> {
  return httpClient.post<OrgContractTermsVersionResponse>(
    `/platform/orgs/${orgId}/contract-versions`,
    data,
  );
}

export async function getDefaultContractTerms(): Promise<DefaultContractTermsState> {
  return httpClient.get<DefaultContractTermsState>("/platform/contract-defaults");
}

export async function publishDefaultContractTerms(
  data: PublishDefaultContractTermsRequest,
): Promise<DefaultContractTermsPublicationResult> {
  return httpClient.post<DefaultContractTermsPublicationResult>(
    "/platform/contract-defaults",
    data,
  );
}

export async function applyDefaultContractTerms(
  orgId: UUID,
): Promise<OrgContractTermsVersionResponse | null> {
  return httpClient.post<OrgContractTermsVersionResponse | null>(
    `/platform/orgs/${orgId}/contract-terms/use-default`,
    {},
  );
}

export async function listContractVersions(
  orgId: UUID,
): Promise<OrgContractTermsVersionResponse[]> {
  return httpClient.get<OrgContractTermsVersionResponse[]>(
    `/platform/orgs/${orgId}/contract-versions`,
  );
}

export interface OnboardingOrgDisplay {
  org_id: string;
  business_name: string;
  status: string;
  contract_version?: number | null;
  contract_sent_at?: string | null;
  contract_accepted_at?: string | null;
  created_at: string;
}

export async function listOnboardingOrgs(): Promise<PlatformOnboardingPipeline> {
  return httpClient.get<PlatformOnboardingPipeline>("/platform/onboarding");
}
